const cover =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/library/library_img.webp";
const dpf =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Eee/girl.webp";
const dpm =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Ece/boy.webp";
const Geetha = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/3.Dr.S.GEETHA.webp"
// const chandraprabha =
//   "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Cse/Faculties/Teaching_fac/chandraprabha.webp";

const librarymenu = [
  {
    id: "1",
    path: "/library",
    link: "About the Library",
    arl: "l",
  },
  {
    id: "2",
    path: "/library/Rules_and_regulations",
    link: "Rules and Regulations",
    arl: "l",
  },
  {
    id: "3",
    path: "/library/E_resources_and_journals",
    link: "E-resources and Journals",
    arl: "l",
  },
  {
    id: "4",
    path: "/library/Privileges",
    link: "Privileges of members",
    arl: "l",
  },
  {
    id: "5",
    path: "/library/Other_facility",
    link: "Other Facilities",
    arl: "l",
  },
  {
     id: "6",
     path: "/library/AItools",
     link:  "AI Tools",
     arl:  "l",
  }
];
const AItoolsmenu = [
  {
    id: "1",
    path: "/library/AItools",
    link: "AI - Tools",
    arl: "l",
  },
  {
    id: "2",
    path: "/library/AItools/Notetaking",
    link: "Research and Notes Taking",
    arl: "l",
  },
  {
    id: "3",
    path: "/library/AItools/Essaywriting",
    link: "Essay Writing and Grammar",
    arl: "l",
  },
  {
    id: "4",
    path: "/library/AItools/Productivity",
    link: "Productivity and Wellness",
    arl: "l",
  },
  {
    id: "5",
    path: "/library/AItools/Examprep",
    link: "Exam Preparation",
    arl: "l",
  },
  {
    id: "6",
    path: "/library/AItools/Careerplanning",
    link: "Career Planning and Resume Tools",
    arl: "l",
  },
  {
    id: "7",
    path: "/library/AItools/Presentations",
    link: "Presentation and Slide Makers",
    arl: "l",
  },
  {
    id: "8",
    path: "/library/AItools/Studyassistants",
    link: "Study Assistants and Chatbots",
    arl: "l",
  },
];
const libraryOfficers = [
  // {
  //   id: "1",
  //   cover: cover,
  //   dp: chandraprabha,
  //   name: "K.Chandraprabha",
  //   Designation: "Asso.Prof. CSE,  Library officer",
  //   mailid: "kcprabha@gmail.com",
  //   pdf: "https://drive.google.com/file/d/1vLl4q7g8vqOGGjfTlJQvFL1tkmoLVfVM/view?usp=drive_link",
  // },
   {
    id: "3",
    cover: cover,
    dp: Geetha,
    name: "Dr.S.Geetha",
    Designation: "Associate Professor Mech,  Library officer",
    mailid: "gitskumaresh@gmail.com",
    pdf: "https://drive.google.com/file/d/1CGoWXRb2pFeQoL4EvHqkbWo5QNtAWYIR/view?usp=sharing",

  },
  // {
  //   id: "1",
  //   cover: cover,
  //   dp: chandraprabha,
  //   name: "K.Chandraprabha",
  //   Designation: "Asso.Prof. CSE,  Library officer",
  //   mailid: "kcprabha@gmail.com",
  //   pdf: "https://drive.google.com/file/d/1vLl4q7g8vqOGGjfTlJQvFL1tkmoLVfVM/view?usp=drive_link",
  // },
  {
    id: "2",
    cover: cover,
    dp: dpf,
    name: "Dr.RM.Subbulakshmi",
    Designation: "Librarian (i/c) T",
    mailid: "",
    pdf: "",
  },
];
const supportingStaffs = [
  {
    id: "3",
    cover: cover,
    dp: dpf,
    name: "R.Hema",
    Designation: "Instrument Repair",
    mailid: "",
    pdf: "",
  },
  {
    id: "4",
    cover: cover,
    dp: dpm,
    name: "K.Saravanan",
    Designation: "Junior Assistant",
    mailid: "",
    pdf: "",
  },
  {
    id: "5",
    cover: cover,
    dp: dpf,
    name: "T.Amutha",
    Designation: "Library Attender",
    mailid: "",
    pdf: "",
  },
  {
    id: "6",
    cover: cover,
    dp: dpm,
    name: "K.SanjaiGanthi",
    Designation: "Cleaner",
    mailid: "",
    pdf: "",
  },
];

const libraryRules = [
  {
    id: "1",
    point:
      "Entry to the library is permitted only upon presenting a valid ID card.",
  },
  {
    id: "2",
    point:
      "All bags must be deposited at the property counter before entering the library premises.",
  },
  {
    id: "3",
    point:
      "Consumption of food or beverages is strictly prohibited inside the library.",
  },
  {
    id: "4",
    point:
      "Reference materials are for in-library use only and must not be taken outside under any circumstances.",
  },
  {
    id: "5",
    point:
      "Users are requested to cooperate with staff during exit checks of books and personal items.",
  },
  {
    id: "6",
    point:
      "Overdue fines will be imposed for books returned past the due date.",
  },
  {
    id: "7",
    point:
      "In the event of loss or damage of a borrowed book, it must be replaced according to ACGCET library policy.",
  },
  {
    id: "8",
    point:
      "Digital library resources must be used strictly for academic and educational purposes only.",
  },
  {
    id: "9",
    point:
      "Installation or removal of any software or system services on library computers is not allowed.",
  },
  {
    id: "10",
    point:
      "Any violation of the library rules will lead to disciplinary action as per institutional guidelines.",
  },
];
const privilegesvalues = [
  {
    sno: 1,
    desig: "Students UG",
    books: "3",
    return: "30 days",
    fine: "50 paisa",
  },
  {
    sno: 2,
    desig: "Student PG",
    books: "4",
    return: "30 days",
    fine: "50 paisa",
  },
  {
    sno: 3,
    desig: "TRA",
    books: "6",
    return: "30 days",
    fine: "50 paisa",
  },
  {
    sno: 4,
    desig: "Faculty",
    books: "8",
    return: "Semester",
    fine: "-",
  },
  {
    sno: 5,
    desig: "Non Teaching staff",
    books: "3",
    return: "Semester",
    fine: "-",
  },
];

const privilegescolumn = [
  { field: "sno", header: "sno" },
  { field: "desig", header: "Designation" },
  { field: "books", header: "Borrowing No of Books" },
  { field: "return", header: "Return Period	Fine" },
  { field: "fine", header: "Fine" },
];
const libraryfacility = [
  {
    id: "1",
    point: "OPAC",
  },
  {
    id: "2",
    point: "Gate Register",
  },
  {
    id: "3",
    point: "Reprography",
  },
  {
    id: "4",
    point: "Printer",
  },
  {
    id: "5",
    point: "Internet",
  },
  {
    id: "6",
    point: "Anna Edusat Program Facility",
  },
  {
    id: "7",
    point: "Virtual Class Room Facility",
  },
  {
    id: "8",
    point: "Uninterrupted power supply",
  },
  {
    id: "9",
    point: "CCTV Camera",
  },
  {
    id: "10",
    point: "Purified Drinking Water",
  },
  {
    id: "11",
    point: "Institutional Membership- INFLIBNET , DELNET",
  },
  {
    id: "12",
    point: "Old Question Paper",
  },
  {
    id: "13",
    point: "Thesis",
  },
];

const aiToolsData = [
  {
    id: 1,
    title: "TLOOTO AI ",
    description: {
      heading: "Overview",
      text: `Tlooto is an AI-powered research assistant platform that helps students and researchers. It 
                  utilizes a proprietary algorithm to analyze over 300 million academic papers and provides 
                  personalized reports with citations, according to MWC Barcelona. The platform also includes 
                  a Copilot tool that offers real-time answers using LLM and deep learning, according to MWC 
                  Barcelona. Codecrain, a Techstars graduate and 2023 SME Minister’s Award recipient, is a pioneering AI 
                  ResearchTech company developing innovative academic solutions. Its platform, tlooto 
                  (tlooto.com), leverages the proprietary Triple Helix algorithm to analyze over 300 million 
                  academic papers, delivering tailored reports with citations. Serving 1.2 million monthly 
                  researchers worldwide and over 30 Korean universities, tlooto accelerates research 
                  efficiency. The newly launched tlooto Copilot (copilot.tlooto.com) provides advanced real
                  time answers powered by LLM and deep learning. Codecrain collaborates with global leaders 
                  like Oracle and SK Telecom, redefining academic and AI-driven solutions for institutions and 
                  businesses globally.`
    },
    link: {
      heading: "Learn More",
      url: "  https://tlooto.com",
    },
  },
  {
    id: 2,
    title: "Notebook LM",
    description: {
      heading: "Overview",
      text: `Notebook LM is an AI – Powered research and writing tool that help you summarize and
            extract information across dense and complex sources.  You can upload PDFs, Google Docs, 
            Google Slides, Website, URLs and more to build a notebook with many sources. 
            While popular for personal use, Notebook LM's personal product lacks the compliance and 
            the administrative features necessary for enterprise environments. For example, unlike 
            Notebook LM Enterprise, the personal Notebook LM isn't VPC-SC compliant and supports 
            fewer sources. Notebook LM Enterprise includes all the Notebook LM Plus functionality as well as enterprise 
            grade security and compliance.`
    },
    features: {
      heading: "Key Features",
      list: [
        "AI-Powered Research: Summarizes documents and finds key themes/connections.",
        "Document Integration: Supports PDFs, Google Docs, websites, and more.",
        "Interactive Learning: Q&A with source citations and study guide creation.",
        "Personalized Learning: Organize content into topic-specific notebooks.",
        "Multimodal Capabilities: Processes text, images, and more using Gemini.",
        "Audio Overviews: Generates multilingual audio summaries of your notes.",
      ],
    },
    benefits: {
      heading: "Benefits",
      list: [
        "Enhanced Comprehension: Understand complex data through AI summarization.",
        "Increased Efficiency: Automates citation and summary work.",
        "Improved Learning: Create personalized learning materials with ease.",
      ],
    },
    link: {
      heading: "Learn More",
      url: "https://cloud.google.com/agentspace/notebooklmenterprise/docs/overview",
    },
  },
  {
    id: 3,
    title: "ALICE.TECH AI",
    description: {
      heading: "Overview",
      text: `Alice.tech is an AI-driven learning platform that uses artificial intelligence to personalize 
              learning and improve student outcomes. It offers features like personalized notes, quizzes, 
              and flashcards, along with an AI chat that supports understanding and provides feedback, 
              according to Y Combinator. Alice.tech also helps students identify their knowledge gaps and 
              create personalized study plans, according to Cherry Ventures.`
    },
    features: {
      heading: "Key Features",
      list: [
        "AI-Powered Chat",
        "Adaptive Exercises",
        " Real-Time Feedback",
        "Study Plans",
        "Social Learning",
        "Teacher Tools",
      ],
    },
    
    link: {
      heading: "Learn More",
      url: "https://www.alice.tech/",
    },
  },
  {
    id: 4,
    title: "JULIUS AI",
    description: {
      heading: "Overview",
      text: `Julius AI is a personal data analyst tool that specializes in analyzing structured data. It helps 
            you to interpret, analyze, and visualize complex data in a user-friendly manner, making data 
            analysis accessible to individuals without a background in data science or statistics. 
            You can connect various data sources like Excel Sheets, Google Sheets, and Postgres to Julius 
            AI. Once the data is loaded, you can ask questions or give commands, and Julius AI will 
            perform the analysis, identify trends, and generate visualizations to provide insights on the 
            data.`
    },
    features: {
      heading: "Key Features",
      list: [
        "Data analysis",
        "Versatile data source connectivity",
        "Data visualization",
        "User friendly interface",
        "Simplify complex data analysis and visualization tasks."
      ],
    },
    link: {
      heading: "Learn More",
      url: "https://julius.ai/ ",
    },
  },
  {
    id: 5,
    title: "IRIS AI",
    description: {
      heading: "Overview",
      text: `Iris is India's first AI teacher robot, designed to revolutionize education by offering 
              personalized learning experiences and engaging students in interactive activities. It's a voice
              controlled AI assistant that can respond to queries, explain concepts, and deliver educational 
              content. Iris is equipped with a 4-wheel chassis for mobility and 5 degrees of freedom in its 
              hands, allowing it to demonstrate concepts and engage in hands-on learning.`
    },
    features: {
      heading: "Key Features",
      list: [
        "AI Voice Assistant",
        "Interactive Learning",
        "Mobility and Interaction",
        "Personalized Learning",
        "Subject Coverage",
        "Language Support : English, Hindi, and Malayalam."
      ],
    },
    link: {
      heading: "Learn More",
      url: "https://iris.ai/",
    },
  },
];

const notestaking = [
  {
    title: "CONSENSUS",
    description: "AI search engine that finds answers from academic papers.",
    reason: "Saves time while researching real scientific answers.",
    link: "https://consensus.app",
    isFree: "Free",
  },
  {
    title: "SCHOLARCY",
    description: "Automatically summarizes long research PDFs.",
    reason: "Saves hours of reading with key point extraction.",
    link: "https://www.scholarcy.com",
    isFree: "Free trial + Paid",
  },
  {
    title: "GLASP",
    description: "Web highlighter + note-taker with social learning features.",
    reason: "Helps students highlight and save insights while browsing.",
    link: "https://glasp.co",
    isFree: "Free",
  },
  {
    title: "WEAVA",
    description:
      "AI-powered research tool to annotate and organize references.",
    reason: "Best for group assignments or citation-heavy tasks.",
    link: "https://www.weavatools.com",
    isFree: "Free + Paid Plans",
  },
  {
    title: "ELICIT",
    description:
      "Research assistant that suggests and summarizes academic papers.",
    reason: "Ideal for thesis, essays, and final-year projects.",
    link: "https://elicit.org",
    isFree: "Free",
  },
  {
    title: "PERPLEXITY AI",
    description:
      "Conversational AI that gives verified web answers with sources.",
    reason: "Excellent for doubt-solving and live referencing.",
    link: "https://www.perplexity.ai",
    isFree: "Free (Pro version available)",
  },
];

const essayWritingAndGrammar = [
  {
    title: "GRAMMARLY",
    description: "Grammar, spelling, and tone correction tool.",
    reason: "Perfect for assignments, cover letters, and formal emails.",
    link: "https://www.grammarly.com",
    isFree: "Free + Paid",
  },
  {
    title: "QUILLBOT",
    description: "Paraphrasing and summarizing tool.",
    reason: "Helps rewrite answers and avoid plagiarism.",
    link: "https://quillbot.com",
    isFree: "Free + Paid",
  },
  {
    title: "SMODIN",
    description: "Essay and paragraph writer with citations.",
    reason: "Makes content creation easier for students.",
    link: "https://smodin.io",
    isFree: "Free + Paid",
  },
  {
    title: "JENNI AI",
    description: "AI that auto-suggests while writing.",
    reason: "Great for essays and academic writing.",
    link: "https://jenni.ai",
    isFree: "Free + Paid",
  },
  {
    title: "SCRIBBR AI CHECKER",
    description: "Detects AI-written content and checks for originality.",
    reason: "For professors or peer checking before submission.",
    link: "https://www.scribbr.com/ai-detector/",
    isFree: "Free",
  },
  {
    title: "HEMINGWAY EDITOR",
    description: "Highlights sentence complexity and grammar flaws.",
    reason: "Helps students improve clarity and readability.",
    link: "https://hemingwayapp.com",
    isFree: "Free",
  },
  {
    title: "MYESSAYWRITER.AI",
    description: "AI tool to generate college-level essays.",
    reason: "Good starting point for rough drafts.",
    link: "https://myessaywriter.ai",
    isFree: "Free",
  },
];
const examPrepAndFlashCards = [
  {
    title: "QUIZLET",
    description: "Flashcard-based learning with AI quizzes and tests.",
    reason: "Reinforces memory with spaced repetition and tests.",
    link: "https://quizlet.com",
    isFree: "Free + Paid",
  },
  {
    title: "ANKIAPP",
    description: "Advanced flashcard app with algorithm-based repetition.",
    reason: "Ideal for medical, NEET, and entrance exam prep.",
    link: "https://www.ankiapp.com",
    isFree: "Free + Paid",
  },
  {
    title: "BRAINSCAPE",
    description: "Intelligent flashcards with progress tracking.",
    reason: "Helps students master topics faster with review insights.",
    link: "https://www.brainscape.com",
    isFree: "Free + Paid",
  },
  {
    title: "KNOWT",
    description: "Turns notes and textbooks into quizzes.",
    reason: "Great for self-tests before exams.",
    link: "https://www.knowt.io",
    isFree: "Free",
  },
  {
    title: "STUDYSMARTER",
    description: "All-in-one platform for notes, flashcards, and study plans.",
    reason: "Structured study planning with built-in AI assistant.",
    link: "https://www.studysmarter.us",
    isFree: "Free + Paid",
  },
  {
    title: "GLEAN",
    description: "Converts lecture recordings into smart summaries.",
    reason: "Great for students with learning differences or who miss classes.",
    link: "https://glean.co",
    isFree: "Free trial + Paid",
  },
  {
    title: "NEUROFLASH QUIZ GENERATOR",
    description: "Automatically generates quiz questions from any input text.",
    reason: "Useful for mock test prep from textbooks or notes.",
    link: "https://neuroflash.com",
    isFree: "Free + Paid",
  },
];

const presentationAndSlides = [
  {
    title: "TOME",
    description: "AI-powered storytelling and presentation tool.",
    reason:
      "Helps create beautiful slide decks with text and visuals in minutes.",
    link: "https://tome.app",
    isFree: "Free + Paid",
  },
  {
    title: "GAMMA",
    description: "Modern presentation builder with AI writing and design.",
    reason: "Easy drag-drop and auto-beautify features for students.",
    link: "https://gamma.app",
    isFree: "Free + Paid",
  },
  {
    title: "SLIDESAI",
    description: "Turns any text into polished presentation slides.",
    reason: "Saves time creating slides for assignments.",
    link: "https://www.slidesai.io",
    isFree: "Free trial + Paid",
  },
  {
    title: "BEAUTIFUL.AI",
    description:
      "Smart presentation software with AI-based design suggestions.",
    reason: "Great for pitch decks, seminars, and college events.",
    link: "https://www.beautiful.ai",
    isFree: "Free + Paid",
  },
  {
    title: "VISME",
    description: "Create infographics, presentations, and reports.",
    reason: "Ideal for project visuals and posters.",
    link: "https://www.visme.co",
    isFree: "Free + Paid",
  },
  {
    title: "CANVA MAGIC DESIGN",
    description: "AI-enhanced presentation builder within Canva.",
    reason: "Loved by students for simplicity and templates.",
    link: "https://www.canva.com",
    isFree: "Free + Paid",
  },
  {
    title: "PITCH",
    description: "Collaborative presentation maker with AI features.",
    reason: "Best for team projects and live college seminars.",
    link: "https://pitch.com",
    isFree: "Free",
  },
];

const studyAssistantsAndChatbots = [
  {
    title: "CHATGPT",
    description:
      "All-in-one AI assistant for explanations, doubts, ideas, and tutoring.",
    reason: "Your personal study buddy available 24/7.",
    link: "https://chat.openai.com",
    isFree: "Free + Paid (Pro)",
  },
  {
    title: "GOOGLE GEMINI",
    description: "Google’s own AI assistant with search-powered answers.",
    reason: "Great for real-time facts and creative writing help.",
    link: "https://gemini.google.com",
    isFree: "Free",
  },
  {
    title: "YOUCHAT",
    description: "Search-integrated chatbot with web-sourced replies.",
    reason: "Combines AI with real-time Google-like results.",
    link: "https://you.com/chat",
    isFree: "Free",
  },
  {
    title: "MERLIN AI",
    description:
      "Browser extension that adds ChatGPT-style support to any webpage.",
    reason: "Super helpful while studying online.",
    link: "https://www.getmerlin.in",
    isFree: "Free + Paid",
  },
  {
    title: "POE BY QUORA",
    description: "Chat with multiple AI models in one app (Claude, GPT, etc).",
    reason: "Flexible tool to try different AI personalities.",
    link: "https://poe.com",
    isFree: "Free + Paid",
  },
  {
    title: "REPLIKA",
    description: "AI companion that talks, encourages, and guides you.",
    reason:
      "Good for motivation, venting, or companionship during study stress.",
    link: "https://replika.com",
    isFree: "Free + Paid",
  },
  {
    title: "MINDGRASP",
    description: "Upload lectures, notes, or videos — get summaries and Q&As.",
    reason: "Great for lecture revision, fast Q&A generation.",
    link: "https://mindgrasp.ai",
    isFree: "Free trial + Paid",
  },
];

const careerPlanningAndResumes = [
  {
    title: "KICKRESUME",
    description: "AI resume and cover letter builder.",
    reason:
      "Generates job-ready resumes tailored for internships and college jobs.",
    link: "https://www.kickresume.com",
    isFree: "Free + Paid",
  },
  {
    title: "REZI",
    description: "AI resume optimizer with keyword focus for ATS systems.",
    reason: "Ensures your resume passes hiring filters.",
    link: "https://www.rezi.ai",
    isFree: "Free + Paid",
  },
  {
    title: "TEAL RESUME BUILDER",
    description: "Career dashboard and resume maker with job-tracking.",
    reason: "Organizes job applications and AI-enhanced resume writing.",
    link: "https://www.tealhq.com",
    isFree: "Free",
  },
  {
    title: "JOBSCAN",
    description: "Matches your resume with job descriptions.",
    reason: "Boosts chances of selection with resume/job matching.",
    link: "https://www.jobscan.co",
    isFree: "Free trial + Paid",
  },
  {
    title: "ZETY",
    description: "AI-powered resume and cover letter builder.",
    reason: "Customizes formats based on profession and tone.",
    link: "https://zety.com",
    isFree: "Free + Paid",
  },
  {
    title: "RESUMA.I. BY WONSULTING",
    description: "AI resume builder focused on getting interviews.",
    reason: "Created by job coaching pros — simple, optimized outputs.",
    link: "https://resumai.wonsulting.com",
    isFree: "Free",
  },
  {
    title: "LINKEDIN CAREER EXPLORER",
    description:
      "Suggests careers based on your skills and shows real job listings.",
    reason: "Helps undecided students figure out career paths.",
    link: "https://linkedin.github.io/career-explorer",
    isFree: "Free",
  },
];

const productivityAndWellness = [
  {
    title: "NOTION AI",
    description: "Combines note-taking, to-do lists, and AI productivity.",
    reason: "Keeps students organized with AI-powered task handling.",
    link: "https://www.notion.so/product/ai",
    isFree: "Free + Paid",
  },
  {
    title: "REFLECTLY",
    description: "AI journaling app focused on mental wellness.",
    reason: "Helps students reduce anxiety and track thoughts.",
    link: "https://reflectly.app",
    isFree: "Free + Paid",
  },
  {
    title: "TALKPAL AI",
    description: "AI language partner that lets you practice speaking.",
    reason: "Perfect for improving English fluency and confidence.",
    link: "https://talkpal.ai",
    isFree: "Free + Paid",
  },
];


export default notestaking;

export {
  librarymenu,
  libraryOfficers,
  supportingStaffs,
  libraryRules,
  privilegescolumn,
  privilegesvalues,
  libraryfacility,
  aiToolsData,
  AItoolsmenu,
  notestaking,
  essayWritingAndGrammar,
  examPrepAndFlashCards,
  presentationAndSlides,
  studyAssistantsAndChatbots,
  careerPlanningAndResumes,
  productivityAndWellness,
};
